import { APIClient } from './api_helper'
import * as url from './url_helper'

const api = new APIClient()
// const SOCIALBOOTH_API_BASE_URL =
//   process.env.REACT_APP_SOCIALBOOTH_API_URL || 'http://localhost:3001'
// const SOCIALBOOTH_API_BASE_URL =
//   process.env.REACT_APP_SOCIALBOOTH_API_URL || 'http://185.92.1.108:3001'
const SOCIALBOOTH_API_BASE_URL =
  process.env.REACT_APP_SOCIALBOOTH_API_URL || 'https://api.socialboothtr.com'

/**
 * Relative image path'i tam URL'ye çevir.
 * "/uploads/assets/bg.jpg" → "https://api.socialboothtr.com/uploads/assets/bg.jpg"
 * Zaten tam URL ise (http/https) aynen döner.
 */
export const getAssetUrl = (imageLink: string): string => {
  if (!imageLink) return ''
  if (imageLink.startsWith('http://') || imageLink.startsWith('https://')) return imageLink
  return `${SOCIALBOOTH_API_BASE_URL}${imageLink}`
}

const buildQueryString = (params: Record<string, any>) => {
  if (!params || typeof params !== 'object') return ''
  const query = new URLSearchParams()
  Object.keys(params).forEach((key) => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })
  const qs = query.toString()
  return qs ? `?${qs}` : ''
}

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem('user')
  if (user) return JSON.parse(user)
  return null
}

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Login Method
export const postLogin = (data: any) => api.create(url.POST_LOGIN, data)

// Register Method
export const postRegister = (data: any) => api.create(url.POST_REGISTER, data)

// search booth records
export const searchBoothRecords = (params: any) => {
  return api.get(url.BOOTH_RECORD_PATH, params)
}

// create booth record
export const createBoothRecord = (params: any) => {
  return api.create(url.BOOTH_RECORD_PATH, params)
}

//update booth record
export const updateBoothRecord = (params: any, id: string) => {
  return api.put(`${url.BOOTH_RECORD_PATH}/${id}`, params)
}

//delete booth record
export const deleteBoothRecord = (id: string) => {
  return api.delete(`${url.BOOTH_RECORD_PATH}/${id}`)
}

//search & get locations
export const fetchLocations = (params: any) => {
  return api.get(url.LOCATION_PATHS, params)
}

// create booth location
export const createLocationRecord = (params: any) => {
  return api.create(url.LOCATION_PATHS, params)
}

//update booth location
export const updateLocationRecord = (params: any, id: string) => {
  return api.put(`${url.LOCATION_PATHS}/${id}`, params)
}

//delete location
export const deleteLocation = (id: string) => {
  return api.delete(`${url.LOCATION_PATHS}/${id}`)
}

//search & get action price
export const fetchActionPrices = (params: any) => {
  return api.get(url.ACTION_PRICE_PATHS, params)
}

// create booth action price
export const createActionPriceRecord = (params: any) => {
  return api.create(url.ACTION_PRICE_PATHS, params)
}

//update booth action price
export const updateActionPriceRecord = (params: any) => {
  return api.put(
    `${url.ACTION_PRICE_PATHS}/action/${params.actionId}/currency/${params.currencyId}`,
    params
  )
}

//delete action price
export const deleteActionPrice = (actionId: string, currencyId: string) => {
  return api.delete(`${url.ACTION_PRICE_PATHS}/action/${actionId}/currency/${currencyId}`)
}

//search & get events
export const fetchEvents = (params: any) => {
  return api.get(url.EVENT_PATHS, params)
}

// create events
export const createEventRecord = (params: any) => {
  return api.create(url.EVENT_PATHS, params)
}

//update events
export const updateEventRecord = (params: any, id: string) => {
  return api.put(`${url.EVENT_PATHS}/${id}`, params)
}

//delete events
export const deleteEvent = (id: string) => {
  return api.delete(`${url.EVENT_PATHS}/${id}`)
}

//update multi event booths
export const updateEventBooths = (params: any) => {
  return api.create(`${url.EVENT_BOOTH_PATHS}/bulk`, params)
}

//search & get promotions
export const fetchPromotions = (params: any) => {
  return api.get(url.PROMOTION_PATHS, params)
}

// create promotions
export const createPromotionRecord = (params: any) => {
  return api.create(url.PROMOTION_PATHS, params)
}

//update promotions
export const updatePromotionRecord = (params: any, id: string) => {
  return api.put(`${url.PROMOTION_PATHS}/${id}`, params)
}

//delete promotions
export const deletePromotion = (id: string) => {
  return api.delete(`${url.PROMOTION_PATHS}/${id}`)
}

//search & get promotion booths
export const fetchPromotionBooths = (params: any) => {
  return api.get(url.PROMOTION_BOOTH_PATHS, params)
}

//update multi promotion booths
export const updatePromotionBooths = (params: any) => {
  return api.create(`${url.PROMOTION_BOOTH_PATHS}/bulk`, params)
}

//search & get users
export const fetchUsers = (params: any) => {
  return api.get(url.USER_PATHS, params)
}

// create user
export const createUserRecord = (params: any) => {
  return api.create(`${url.USER_PATHS}/register`, params)
}

//update user
export const updateUserRecord = (params: any, id: string) => {
  return api.put(`${url.USER_PATHS}/${id}`, params)
}

//delete user
export const deleteUser = (id: string) => {
  return api.delete(`${url.USER_PATHS}/${id}`)
}

//sales
export const fetchSalesRecords = (params: any) => {
  const query = buildQueryString(params)
  return api.get(`${url.SALES_PATH}${query}`, null)
}

//get page permissions
export const fetchPagePermissions = () => {
  return api.get(url.PAGE_PERMISSION_PATHS, null)
}

// search resources
export const searchResources = (type: string, params: any) => {
  switch (type) {
    case 'action':
      return api.get(url.GET_ACTIONS, params)
    case 'language':
      return api.get(url.GET_LANGUAGES, params)
    case 'currency':
      return api.get(url.GET_CURRENCIES, params)
    case 'location':
      return api.get(url.LOCATION_PATHS, params)
    case 'user':
      return api.get(url.USER_PATHS, params)
    case 'page':
      return api.get(url.USER_PATHS, params)
    default:
      return api.get(url.GET_ACTIONS, params)
  }
}

// search actions
export const searchActions = (params: any) => {
  return
}

// ==========================================
// SOCIALBOOTH BACKEND API HELPERS
// ==========================================

// BACKGROUNDS - Arka planlar
export const fetchBackgrounds = () => {
  return api.get(`${url.BACKGROUND_PATHS}/getAllBackgrounds`, null)
}

export const createBackground = (formData: FormData) => {
  return api.create(`${url.BACKGROUND_PATHS}/newBackground`, formData)
}

export const updateBackground = (formData: FormData, id: string) => {
  return api.put(`${url.BACKGROUND_PATHS}/updateBackground/${id}`, formData)
}

export const deleteBackground = (id: string) => {
  return api.delete(`${url.BACKGROUND_PATHS}/deleteBackground/${id}`)
}

// CATEGORIES - Kategoriler
export const fetchCategories = () => {
  return api.get(`${url.CATEGORY_PATHS}/getAllCategories`, null)
}

export const createCategory = (params: any) => {
  return api.create(`${url.CATEGORY_PATHS}/newCategory`, params)
}

export const updateCategory = (params: any, id: string) => {
  return api.put(`${url.CATEGORY_PATHS}/updateCategory/${id}`, params)
}

export const deleteCategory = (id: string) => {
  return api.delete(`${url.CATEGORY_PATHS}/deleteCategory/${id}`)
}

// ACCESSORIES - Aksesuarlar
export const fetchAccessories = () => {
  return api.get(`${url.ACCESSORY_PATHS}/getAllAccessories`, null)
}

export const createAccessory = (formData: FormData) => {
  return api.create(`${url.ACCESSORY_PATHS}/newAccessory`, formData)
}

export const updateAccessory = (formData: FormData, id: string) => {
  return api.put(`${url.ACCESSORY_PATHS}/updateAccessory/${id}`, formData)
}

export const deleteAccessory = (id: string) => {
  return api.delete(`${url.ACCESSORY_PATHS}/deleteAccessory/${id}`)
}

export const fetchAccessoryCategories = () => {
  return api.get(`${url.ACCESSORY_PATHS}/categories`, null)
}

// EFFECTS/FILTERS - Filtreler
export const fetchEffects = () => {
  return api.get(`${url.EFFECT_PATHS}/getAllFilters`, null)
}

export const createEffect = (formData: FormData) => {
  return api.create(`${url.EFFECT_PATHS}/newFilter`, formData)
}

export const updateEffect = (formData: FormData, id: string) => {
  return api.put(`${url.EFFECT_PATHS}/updateFilter/${id}`, formData)
}

export const deleteEffect = (id: string) => {
  return api.delete(`${url.EFFECT_PATHS}/deleteFilter/${id}`)
}

// ACTIVE ACTIONS (Services)
export const fetchActiveActions = () => {
  return api.get(url.GET_ACTIONS, {})
}

export const createActiveAction = (params: any) => {
  return api.create(url.GET_ACTIONS, params)
}

export const updateActiveAction = (params: any, id: string) => {
  return api.put(`${url.GET_ACTIONS}/${id}`, params)
}

export const deleteActiveAction = (id: string) => {
  return api.delete(`${url.GET_ACTIONS}/${id}`)
}

// PHOTO BOOTHS - Booth listesi (for dropdown selection)
export const fetchPhotoBooths = () => {
  return api.get(url.PHOTO_BOOTH_PATHS, null)
}

// TIMER SETTINGS - Zamanlayıcı ayarları
export const fetchTimerSettings = () => {
  return api.get(url.TIMER_SETTINGS_PATH, null)
}

export const updateTimerSettings = (params: any) => {
  return api.put(url.TIMER_SETTINGS_PATH, params)
}

// TRANSLATIONS - Çeviri yönetimi
export const fetchTranslationOverrides = () => {
  return api.get(url.TRANSLATIONS_PATH, null)
}

export const updateTranslationOverrides = (lang: string, translations: Record<string, string>) => {
  return api.put(url.TRANSLATIONS_PATH, { lang, translations })
}

export const deleteTranslationOverride = (lang: string, key: string) => {
  return api.delete(`${url.TRANSLATIONS_PATH}/${lang}/${key}`)
}
